import {useEffect, useState} from 'react';
import {Box, Button, Paper, Typography} from "@material-ui/core";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import {makeStyles} from "@material-ui/core/styles";
import logo from '../assets/logo_white.svg'
import {lighten} from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    container: {
        height: '100%',
        padding: theme.spacing(1),
        marginTop: theme.spacing(2),
        borderRadius: theme.spacing(2),
        flex: '1',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center',
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
        background: '#2f3135',
        '& img': {
            marginBottom: theme.spacing(4),
            width: 128,
        }
    },
    box: {
        boxShadow: '0px 4px 4px #000000',
        maxWidth: '64em',
        borderRadius: theme.shape.borderRadius,
        overflow: 'hidden',
    },
    content: {
        padding: `${theme.spacing(6)}px ${theme.spacing(8)}px`,
        background: '#32363A',
    },
    actions: {
        background: 'rgba(150, 150, 150, 0.56)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: `${theme.spacing(2)}px ${theme.spacing(2)}px`,
    },
    submitButton: {
        color: '#fff',
        backgroundColor: theme.customColors.green,
        '&:hover': {
            backgroundColor: lighten(theme.customColors.green, '0.2'),
        },
    },
    cancelButton: {
        marginRight: theme.spacing(1),
        color: theme.palette.getContrastText(theme.customColors.red),
        backgroundColor: theme.customColors.red,
        '&:hover': {
            backgroundColor: lighten(theme.customColors.red, '0.2'),
        },
    },
}));


const QUESTIONS = [
    "I own the copyright on all the pictures provided.",
    "I confirm that the people visible in the pictures (if any) have given their consent to use the pictures.",
    "I confirm that for the minors visible in the pictures (if any), I have received the consent of the parents or the legal guardians to use the pictures.",
    "In the event that the pictures provided do not meet MazingDay’s quality standards, I allow MazingDay to display a generic illustration of my activity or area of activity in place of the pictures that I have provided."
]

export default function SubmitPage({onNext, onPrev}) {
    const classes = useStyles();
    const [state, setState] = useState(QUESTIONS.map(_ => false));
    const [isValid, setIsValid] = useState(false)
    const [confirmationDialogVisible, setConfirmationDialogVisible] = useState(false);

    const handleCheck = (i) => (e) => {
        const updated = [...state];
        updated[i] = e?.target?.checked;
        setState(updated)
    }

    useEffect(() => {setIsValid(state.reduce((s, v) => s && v, true));}, [state])


    return (
        <Paper className={classes.container}>
            <img src={logo} alt="MazingDay Logo" />
            <Box className={classes.box}>
                <Box className={classes.content}>
                    <Typography variant="h6" gutterBottom>Please accept the below terms and conditions:</Typography>
                    {
                        QUESTIONS.map((question, i) => (
                            <FormControlLabel
                                key={`question_formcontrol_${i}`}
                                control={
                                    <Checkbox
                                        checked={state[i]}
                                        onChange={handleCheck(i)}
                                        name={`question_${i}`}
                                        color="primary"

                                    />
                                }
                                style={{paddingBottom:'15px',paddingTop:'15px'}}
                                label={question}
                            />
                        ))
                    }
                </Box>
                <Box className={classes.actions}>
                    <Button
                        variant="contained" startIcon={<CancelIcon />} style={{marginRight: 8}} className={classes.cancelButton} onClick={onPrev}>Cancel</Button>
                    <Button variant="contained" startIcon={<CheckCircleIcon />} disabled={!isValid} className={classes.submitButton}
                        onClick={() => setConfirmationDialogVisible(true)}>Submit</Button>
                </Box>
            </Box>
            <Dialog fullWidth maxWidth="xs" open={confirmationDialogVisible} style={{background: 'rgba(0,0,0,0.75)'}} onClose={() => setConfirmationDialogVisible(false)} >
                <DialogContent style={{background: '#292D32'}}>
                    <DialogContentText style={{padding: 16, textAlign: 'center'}}>
                        <Typography gutterBottom>
                            Did you upload all the requested files?<br /><br />
                            Once you click on ‘Proceed’, you will not be able to go back.
                        </Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setConfirmationDialogVisible(false)} color="secondary" variant="contained" startIcon={<CancelIcon />}> Go back</Button>
                    <Button onClick={onNext} color="primary" variant="contained" startIcon={<CheckCircleIcon />}>Proceed</Button>
                </DialogActions>
            </Dialog>
        </Paper >
    )
}
